import { useState, useCallback } from 'react';

export function useDeleteModal() {
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    // Abre o modal e define qual item será deletado
    const openDeleteModal = useCallback((item) => {
        setItemToDelete(item);
        setIsDeleteModalOpen(true);
    }, []);

    // Fecha o modal e limpa o item
    const closeDeleteModal = useCallback(() => {
        setIsDeleteModalOpen(false);
        setItemToDelete(null);
    }, []);

    return {
        isDeleteModalOpen,
        itemToDelete,
        openDeleteModal,
        closeDeleteModal
    };
}